import"core-js/modules/web.dom-collections.for-each.js";
import _Object$keys from"@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from"@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from"@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from"@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from"@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from"@babel/runtime-corejs3/core-js-stable/object/define-property";
import _slicedToArray from"@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from"@babel/runtime-corejs3/helpers/defineProperty";
import"core-js/modules/es.object.to-string.js";
import"core-js/modules/es.promise.js";
import _sliceInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/slice";
import _URL from"@babel/runtime-corejs3/core-js-stable/url";
import _includesInstanceProperty from"@babel/runtime-corejs3/core-js-stable/instance/includes";
import _JSON$stringify from"@babel/runtime-corejs3/core-js-stable/json/stringify";
function ownKeys(e,r){var t=_Object$keys(e);
    if(_Object$getOwnPropertySymbols){var o=_Object$getOwnPropertySymbols(e);
    r&&(o=_filterInstanceProperty(o).call(o,(function(r){return _Object$getOwnPropertyDescriptor(e,r).enumerable}))),t.push.apply(t,o)}return t}function _objectSpread(e){for(var r=1;
    r<arguments.length;
    r++){var t=null!=arguments[r]?arguments[r]:{};
r%2?ownKeys(Object(t),!0).forEach((function(r){_defineProperty(e,r,t[r])})):_Object$getOwnPropertyDescriptors?_Object$defineProperties(e,_Object$getOwnPropertyDescriptors(t)):ownKeys(Object(t)).forEach((function(r){_Object$defineProperty(e,r,_Object$getOwnPropertyDescriptor(t,r))}))}return e}import React,{useCallback,useEffect,useMemo,useState}from"react";
import{OidcClient}from"@axa-fr/oidc-client";
import{getConfigValue}from"@jutro/config";
import{joinUrl}from"@jutro/platform";
import{useAuthStorage}from"../storage/useAuthStorage";
import{AuthContext,AuthContextInternal}from"./AuthContext";
import{CONFIGURATION_NAME}from"./constants";
import{getOidcConfiguration}from"./getOidcConfiguration";
import{OidcRoutes}from"./OidcRoutes";
import{OidcSession}from"./OidcSession";
import{swPolyfill}from"./swPolyfill";
swPolyfill();


/**Custom code for redirect */
const getAppName = () => {
    const logoutRedirectPath = String(getConfigValue("JUTRO_AUTH_LOGOUT_REDIRECT_PATH",""))
    if (logoutRedirectPath.includes("producer-engage")) {
        return "PE"
    } else if (logoutRedirectPath.includes("customer-engage") || logoutRedirectPath.includes("account-management")) {
        return "CE"
    }
    return ""
}

const getAppDomain = () => {
    // Extract hostname from window.location
    const { hostname } = window.location
    if(hostname == "localhost")
        return hostname
    // Parse hostname to return domain
    const index = hostname.indexOf('.')
    return (index > 0 ? hostname.slice(index+1) : hostname)
} 


var mergeParamsIfExists=function(configKey,extraParams){
    var paramsFromConfig=getConfigValue(configKey,"");
    if(!paramsFromConfig)return extraParams;

    try{
        return _objectSpread(_objectSpread({},JSON.parse(paramsFromConfig)),extraParams)
    }
    catch(e){
            throw new Error("Incorrect format of value for ".concat(configKey))}},
            getTokens=function(oidc){
                return null!==oidc.tokens?{
                    accessToken:oidc.tokens.accessToken,idToken:oidc.tokens.idToken
                }:null
            },
            getIsAuthenticated=function(oidc,oidcUser){
                return null!==oidc.tokens&&null!==oidcUser},
                getIsPending=function(oidc,oidcUser,isLoginPending){
                    return isLoginPending||null!==oidc.tokens&&null===oidcUser};
export var getBasePath=function(){
    var _context;
    return _sliceInstanceProperty(_context=new _URL(document.baseURI).pathname).call(_context,1)};


export var GenericAuthProvider=function(_ref){
    var children=_ref.children,onLocationChange=_ref.onLocationChange,basePath=useMemo((function(){
        return getBasePath()}),[]),
        oidc=useMemo((function(){
            return OidcClient.getOrCreate((function(){return fetch}))(getOidcConfiguration(basePath),CONFIGURATION_NAME)}),
            [basePath]),_useState=useState(!1),_useState2=_slicedToArray(_useState,2),isLoginPending=_useState2[0],setIsLoginPending=_useState2[1],
            _useState3=useState((function(){return getTokens(oidc)})),
            _useState4=_slicedToArray(_useState3,2),
            tokens=_useState4[0],
            setTokens=_useState4[1],
            _useState5=useState(null),
            _useState6=_slicedToArray(_useState5,2),
            oidcUser=_useState6[0],
            setOidcUser=_useState6[1],
            _useState7=useState(void 0),
            _useState8=_slicedToArray(_useState7,2),
            error=_useState8[0],
            setError=_useState8[1];

        

    useEffect((function(){
        
        document.cookie = `appNameCookie=${getAppName()}; domain=${getAppDomain()}; path=/`;
        var hasChanged=!1,newSubscriptionId=oidc.subscribeEvents((function(name,data){
            var _context2,_context3;
            hasChanged||(_includesInstanceProperty(_context2=[
                OidcClient.eventNames.logout_from_another_tab,
                OidcClient.eventNames.logout_from_same_tab,
                OidcClient.eventNames.token_aquired,
                OidcClient.eventNames.token_renewed,
                OidcClient.eventNames.tryKeepExistingSessionAsync_end]).call(_context2,name)
                &&
                setTokens(getTokens(oidc)),
                name===OidcClient.eventNames.refreshTokensAsync_error
                &&
                oidc.loginAsync(),
                _includesInstanceProperty(_context3=[OidcClient.eventNames.loginAsync_error,OidcClient.eventNames.loginCallbackAsync_error,OidcClient.eventNames.silentLoginAsync_error,OidcClient.eventNames.syncTokensAsync_error,OidcClient.eventNames.tryKeepExistingSessionAsync_error]).call(_context3,name)&&setError(new Error(name,{cause:_JSON$stringify(data)})))}));
        
            return function(){
            hasChanged=!0,oidc.removeEventSubscription(newSubscriptionId)}}),[oidc]),useEffect((function(){var hasChanged=!1;
    return tokens||setOidcUser(null),
    tokens&&oidc.userInfoAsync()
    .then((function(info){
        hasChanged||setOidcUser(info)
    }))
    .catch((function(err){
        hasChanged||(setOidcUser(null),setError(err))
    })),
    function(){
        hasChanged=!0
    }}),[oidc,tokens]),
    useAuthStorage(tokens);
    var login=useCallback((function(){

        var callbackPath=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",extraParams=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};
        return oidc.loginAsync(callbackPath,mergeParamsIfExists("JUTRO_AUTH_LOGIN_QUERY_EXTRAS",extraParams))
    })
    
    ,[oidc]),
    logout=useCallback((function(fromPath,extraParams){
    var defaultLogoutPath=joinUrl(basePath,getConfigValue("JUTRO_AUTH_LOGOUT_REDIRECT_PATH","/logout")),


    logoutPath=null!=fromPath?fromPath:defaultLogoutPath;
    
    return oidc.logoutAsync(logoutPath,mergeParamsIfExists("JUTRO_AUTH_LOGOUT_QUERY_EXTRAS",extraParams))}),
        [oidc,basePath]),
        contextValue=useMemo((function(){
            var _tokens$accessToken,_tokens$idToken;
    return{
        isAuthenticated:getIsAuthenticated(oidc,oidcUser),
        isPending:getIsPending(oidc,oidcUser,isLoginPending),
        accessToken:null!==(_tokens$accessToken=null==tokens?void 0:tokens.accessToken)&&void 0!==_tokens$accessToken?_tokens$accessToken:null,
        idToken:null!==(_tokens$idToken=null==tokens?void 0:tokens.idToken)&&void 0!==_tokens$idToken?_tokens$idToken:null,
        userInfo:oidcUser,
        error:error,
        login:login,
        logout:logout
    }}), [oidc,isLoginPending,tokens,oidcUser,error,login,logout]),
        internalContextValue=useMemo((function(){
            return{oidc:oidc,setIsLoginPending:setIsLoginPending,setError:setError,onLocationChange:onLocationChange}})
            ,[oidc,onLocationChange]);
    return React.createElement(AuthContext.Provider,{value:contextValue},React.createElement(AuthContextInternal.Provider,{value:internalContextValue},React.createElement(OidcRoutes,null,React.createElement(OidcSession,null,children))))};
